(function() {
  'use strict';

  var productCardSelector = '.shopify-section--main-collection .product-card';

  function getProductData(card, productId) {
    var config = card.querySelector('[data-br-0003-title-config]');

    if (!config || !productId) {
      return null;
    }

    try {
      var data = JSON.parse(config.textContent);

      if (!data.products) {
        return null;
      }

      return data.products.find(function(product) {
        return String(product.id) === String(productId);
      });
    } catch (error) {
      return null;
    }
  }

  function updateSubtitle(target, subtitleText) {
    var subtitle = target.querySelector('[data-br-0003-subtitle]');

    if (!subtitleText) {
      if (subtitle) {
        subtitle.remove();
      }

      return;
    }

    if (!subtitle) {
      subtitle = document.createElement('span');
      subtitle.className = 'br-0003-product-card-title-subtitle';
      subtitle.setAttribute('data-br-0003-subtitle', '');
      target.appendChild(subtitle);
    }

    subtitle.textContent = subtitleText;
  }

  function updateTitle(card, productId) {
    var target = card.querySelector('[data-br-0003-product-card-title]');
    var title = card.querySelector('[data-br-0003-title]');
    var product = getProductData(card, productId);

    if (!target || !title || !product) {
      return;
    }

    target.href = product.url || target.href;
    target.setAttribute('data-br-0003-current-product-id', product.id);
    title.textContent = product.title || '';
    updateSubtitle(target, product.subtitle);
  }

  document.addEventListener('click', function(event) {
    var swatch = event.target.closest('[data-br-0003-product-id]');

    if (!swatch) {
      return;
    }

    var card = swatch.closest(productCardSelector);

    if (!card) {
      return;
    }

    window.setTimeout(function() {
      updateTitle(card, swatch.getAttribute('data-br-0003-product-id'));
    }, 0);
  });
})();
